import React, { useState } from "react"
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper, FlatFeeModalWrapper } from '../../PTPlusStyled'
import { Table } from 'reactstrap';
import { headerArr, palletTypeOptions } from "../../../BuyBackFeeRequests/Constants";
import { ListingDataWrapper } from "../../../BuyBackFeeRequests/BuyBackFeeStyled";

const BuyBackFee = (pageProps) => {

  const { buyBackFeeDataList } = pageProps;

  const [accordionOpen, setAccordionOpen] = useState(false)
  const [accordionOpenIndex, setAccordionOpenIndex] = useState()
  const setAccordionFunction = index => {
    setAccordionOpenIndex(index)
  }

  return (
    <>
      <Container>
        <AccordionHeader>
          <h6 onClick={() => {
            if (accordionOpen) setAccordionOpen(false)
            else setAccordionOpen(true)
          }}>BuyBack Fee</h6>
          {accordionOpen ?
            <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
            : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
          }
        </AccordionHeader>
        {accordionOpen &&
          <AccordionBody>
            <ListingDataWrapper>
              <div>
                <Table responsive>
                  <thead>
                    <tr style={{ background: "rgba(243, 243, 243, 1)" }}>
                      {headerArr.map((items, index) => (
                        <th key={`table-header-${index}`} style={{ color: "rgba(0, 85, 134, 1)" }}>
                          {(items.title).toUpperCase()}
                        </th>
                      ))}
                      <th>{/*Placeholder for action column*/}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {buyBackFeeDataList && buyBackFeeDataList.length > 0 && buyBackFeeDataList.map((items, index) => (
                        <>
                          <tr key={index} className='user-list-table-styles'>
                            <td className="font-weight-bold">{items?.customerName}</td>
                            <td>{items?.customerLocationName}</td>
                            <td colspan="1">{items?.street}</td>
                            <td colspan="1">{items?.city}</td>
                            <td colspan="1">{items?.state}</td>
                            <td
                              className='expand-collapse-class'
                              style={{ display: 'flex', alignItems: "center", justifyContent: "end" }}
                            >
                              {(accordionOpenIndex === index) ?
                                <h4 onClick={() => {
                                  setAccordionFunction()
                                }}><i></i></h4>
                                : <h5 onClick={() => {
                                  setAccordionFunction(index)
                                }}><i></i></h5>
                              }
                            </td>
                          </tr>

                          {accordionOpenIndex === index &&
                            <tr>
                              <td colSpan={headerArr.length + 1} style={{ padding: "0" }}>
                                <table
                                  style={{
                                    background: "#E4F2FA",
                                    width: "100%"
                                  }}
                                  className="fee-items-table"
                                >
                                  {/* Heading for collapse section */}
                                  <thead>
                                    <tr className='order-details-wrapper-heading'>
                                      <td><h6>BuyBack Vendor</h6></td>
                                      <td><h6>Pallet Type</h6></td>
                                      <td><h6>Customer Price</h6></td>
                                      <td><h6>Vendor Price</h6></td>
                                      <td><h6>Start Date</h6></td>
                                      <td><h6>End Date</h6></td>
                                      <td><h6>Comment</h6></td>
                                    </tr>
                                  </thead>

                                  {/* Fee items */}
                                  <tbody>
                                    {items.vendors && items.vendors.length > 0 && items.vendors.map((vendor, vendorIndex) => (
                                      vendor.feeDetails && vendor.feeDetails.length > 0 && vendor.feeDetails.map((feeDetail, feeIndex) => (
                                        <tr className='order-details-wrapper' key={`${vendorIndex}_${feeIndex}`}>
                                          <td>
                                            <p style={{ whiteSpace: 'nowrap' }}>{`${vendor?.vendorLocationName} - ${vendor?.city}, ${vendor?.state}`}</p>
                                          </td>
                                          <td>
                                            <p style={{ whiteSpace: 'nowrap' }}>
                                              {palletTypeOptions.map(option => {
                                                if (option.value === feeDetail?.pickupPalletType) {
                                                  return option.label;
                                                };
                                              })}
                                            </p>
                                          </td>
                                          <td>
                                            <p style={{ whiteSpace: 'nowrap' }}>${feeDetail?.customerFee?.toFixed(2)}</p>
                                          </td>
                                          <td>
                                            <p style={{ whiteSpace: 'nowrap' }}>${feeDetail?.vendorFee.toFixed(2)}</p>
                                          </td>
                                          <td>
                                            <p>{feeDetail?.rateStartDate}</p>
                                          </td>
                                          <td>
                                            <p>{feeDetail?.rateExpirationDate}</p>
                                          </td>
                                          <td>
                                            <p title={feeDetail?.comment}>
                                              {feeDetail?.comment?.length > 20 ? (feeDetail?.comment?.substring(0, 20).concat('...')) : (feeDetail?.comment ? feeDetail?.comment : 'NA')}
                                            </p>
                                          </td>
                                        </tr>
                                      ))
                                    ))}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          }
                        </>
                      ))}

                  </tbody>

                </Table>
              </div>
            </ListingDataWrapper>
          </AccordionBody>
        }
      </Container>
    </>
  )
}

export default BuyBackFee